/* Amelin & Co: wejścia elementów przy przewijaniu (IntersectionObserver + kontrola przy scrollu), kaskada w obrębie rodzica.
   Zasady: tylko opacity i transform, 500 ms ease-out, raz na element, nic bez JS nie jest ukryte. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var CELE = [
    '.collection .grid__item', '.kp-kafle__k', '.kp-spol__el', '.kp-spol__karta', '.kp-zaufanie > *',
    '.collapsible-content__header', '.collapsible-content__grid', '.kp-opinia', '.multicolumn-card', '.rich-text__blocks',
    '.image-with-text__content', '.kp-linie li', '.kp-dostawa', '.kp-rabat', '.footer-block'
  ];
  var czekajace = [];
  function widoczny(e) {
    var r = e.getBoundingClientRect();
    return r.top < window.innerHeight * 0.95 && r.bottom > 0 && r.left < window.innerWidth && r.right > 0;
  }
  function pokaz(e) { e.classList.add('kp-in'); io.unobserve(e); }
  function sprawdz() {
    czekajace = czekajace.filter(function (e) { if (widoczny(e)) { pokaz(e); return false; } return true; });
  }
  var io = new IntersectionObserver(function (wpisy) {
    wpisy.forEach(function (w) { if (w.isIntersecting) pokaz(w.target); });
    czekajace = czekajace.filter(function (e) { return !e.classList.contains('kp-in'); });
  }, { rootMargin: '0px 0px -5% 0px', threshold: 0.05 });
  function przygotuj(root) {
    var el = (root || document).querySelectorAll(CELE.join(','));
    var grupy = new Map();
    el.forEach(function (e) {
      if (e.classList.contains('kp-reveal') || e.classList.contains('kp-in')) return;
      if (widoczny(e)) { e.classList.add('kp-in'); return; }   // już na ekranie: nie ukrywamy
      var p = e.parentElement; var n = grupy.get(p) || 0; grupy.set(p, n + 1);
      e.style.setProperty('--kp-krok', Math.min(n, 7));
      e.classList.add('kp-reveal');
      czekajace.push(e); io.observe(e);
    });
  }
  var tik = false;
  function naScroll() { if (tik) return; tik = true; requestAnimationFrame(function () { tik = false; sprawdz(); }); }
  document.documentElement.classList.add('kp-js');
  function start() {
    przygotuj();
    document.addEventListener('scroll', naScroll, true);   // capture: także karuzele i inne przewijane kontenery
    window.addEventListener('resize', naScroll);
    setTimeout(sprawdz, 400);
    var licznik = setInterval(function () { sprawdz(); if (!czekajace.length) clearInterval(licznik); }, 700);   // siatka bezpieczeństwa: przesunięcia układu po doładowaniu zdjęć
    setTimeout(function () { czekajace.forEach(pokaz); czekajace = []; clearInterval(licznik); }, 8000);   // ostatni bezpiecznik: nic nie zostaje ukryte
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { przygotuj(e.target); sprawdz(); });
})();
